import { CpdlcMessage, cpdlcMsgDescriptionMap, createCpdlcMsgElement, getResponseAttribute, } from "./cpdlcMessage.js";
export * from "./cpdlcMessage.js";
export const eramCpdlcErrorMessages = ["UM159", "UM162", "DM62", "DM63", "DM107"];
export const notSentEramCpdlcMsgTypes = ["NBNS", "BBNS"];
export class EramCpdlcMessage extends CpdlcMessage {
    originator = null;
    dueToReason;
    eramMsgType = "STANDARD";
}
export class EramCpdlcAdvMessage extends EramCpdlcMessage {
    advisory;
    constructor(elements, advisory) {
        super("UM", elements);
        this.advisory = advisory;
    }
    eramMsgType = "ADV";
}
/**
 * Transfer of Communication (TOC) uplink message
 * also used for storing HELD TOC messages
 */
export class EramCpdlcTOCMessage extends EramCpdlcMessage {
    elements;
    nextSectorId;
    nextSectorIdShort;
    nextSectorTelephony;
    nextSectorFrequency;
    constructor(elements, nextSectorId, nextSectorIdShort, nextSectorTelephony, nextSectorFrequency) {
        super("UM", elements);
        this.elements = elements;
        this.nextSectorId = nextSectorId;
        this.nextSectorIdShort = nextSectorIdShort;
        this.nextSectorTelephony = nextSectorTelephony;
        this.nextSectorFrequency = nextSectorFrequency;
    }
    // used for HELD TOC frequency dropdown
    nextSectorFrequencies = [];
    eramMsgType = "TOC";
    static setMsgElements(msg, freq, additionalElements = []) {
        msg.status = "OPEN";
        const elements = [createCpdlcMsgElement("UM117", [msg.nextSectorTelephony, freq]), ...additionalElements];
        msg.elements = elements;
        msg.responseAttribute = getResponseAttribute(elements);
    }
}
export function isTOCMessage(msg) {
    return msg.eramMsgType === "TOC";
}
/**
 * EramCpdlcNotBuiltNotSentMessage
 * This message is created when a CPDLC message could not be sent
 * because either the message could not be built or the uplink failed.
 * A closed dialog containing this message will be created instead.
 */
export class EramCpdlcNotBuiltNotSentMessage extends EramCpdlcMessage {
    description;
    dueToReason;
    constructor(description, dueToReason) {
        super("UM", [createCpdlcMsgElement("UM169", [description])]);
        this.description = description;
        this.dueToReason = dueToReason;
    }
    eramMsgType = "NBNS";
}
/**
 * EramCpdlcBuiltNotSentMessage
 * This message is created when a CPDLC message could not be sent
 * because of an uplink eligibility validation error.
 * A closed dialog containing this message will be created instead.
 */
export class EramCpdlcBuiltNotSentMessage extends EramCpdlcMessage {
    dueToReason;
    constructor(message, dueToReason) {
        super("UM", message.elements);
        this.dueToReason = dueToReason;
    }
    eramMsgType = "BBNS";
}
export function formatEramCpdlcElement(type, parameters) {
    const item = cpdlcMsgDescriptionMap[type];
    if (!item) {
        return null;
    }
    const descriptionFunc = (item.eramDescription ??
        item.description);
    const longDescriptionFunc = item.description;
    return {
        shortDescription: descriptionFunc(parameters).toUpperCase(),
        longDescription: longDescriptionFunc(parameters).toUpperCase(),
    };
}
export function formatCpdlcMessage(message) {
    if (message.eramMsgType === "NBNS") {
        return {
            description: message.description.toUpperCase(),
            longDescription: message.description.toUpperCase(),
        };
    }
    const longDescription = message.elements
        .map((e) => formatEramCpdlcElement(e.type, e.parameters)?.longDescription)
        .filter((e) => !!e)
        .join(" ");
    if (message.eramMsgType === "TOC") {
        const { nextSectorIdShort, nextSectorFrequency } = message;
        return {
            description: `${nextSectorIdShort ?? ""} ${nextSectorFrequency ?? ""}`,
            longDescription,
        };
    }
    if (message.eramMsgType === "ADV") {
        const adv = message.advisory;
        return {
            description: adv.name + (adv.sectorCreatedShort ? `(${adv.sectorCreatedShort})` : ""),
            longDescription,
        };
    }
    return {
        description: message.elements
            .map((e) => formatEramCpdlcElement(e.type, e.shortParameters ?? e.parameters)?.shortDescription)
            .filter((e) => !!e)
            .join(" "),
        longDescription,
    };
}
export const UPLINK_REASON_MAP = {
    "/TFC": ["UM166"],
    "/RES": ["UM167"],
    "/SPC": ["UM169", "DUE TO SPACING"],
    "/WX": ["UM169", "DUE TO WEATHER"],
};
//# sourceMappingURL=eramCpdlcMessage.js.map